import { ProcessMenu } from './menu-processing'
const menu = [
  [
    {
      title: 'Metrics',
      id: 'Metrics-51',
      type: 'group',
      children: [
        {
          title: 'Metrics',
          id: 'Metrics-54',
          type: 'collapse',
          claim: 'Player',
          children: [
            {
              title: 'Metric Configurations',
              id: 'Metric Configurations-52',
              paths: ['/'],
              hidden: false,
              targetView: 'MetricConfiguration',
              type: 'item',
            },
            {
              title: 'Graphs',
              id: 'Graphs-53',
              paths: ['/'],
              hidden: false,
              targetView: 'MetricGraphs',
              type: 'item',
            },
          ],
          script:
            '(function checkAuthorization() : any {\n    if(isLoggedIn && claims && !claims?.player) {\n        navigate(`/${(Views.Home)}`, { replace: true });\n    }\n})();',
        },
      ],
    },
  ],
]
export default ProcessMenu(menu)
